import { UserQuickFilter } from "./UserQuickFilter";

export const UserQuickFilterDisplay: Record<UserQuickFilter, string> = {
  [UserQuickFilter.Active]: "Active",
  [UserQuickFilter.All]: "All Users",
  [UserQuickFilter.Inactive]: "Inactive",
  [UserQuickFilter.RequiresAction]: "Requires Action"
};
